import { useAtom } from '@reatom/npm-react'

import { PairSnipersBundlersInsidersTooltipBody } from './pair-snipers-bundlers-insiders-tooltip-body/pair-snipers-bundlers-insiders-tooltip-body'

import type { PairModel } from '@root/entities/pair/atoms'

export const PairExploreItemAuditSnipersTooltip = ({
  pair,
}: {
  pair: PairModel
}) => {
  const [insiders] = useAtom(pair.insiders)
  const [snipers] = useAtom(pair.snipers)
  const [bundlers] = useAtom(pair.bundlers)
  const insiderHolding = insiders.holding
  const bundlersHolding = bundlers.holding
  const snipersHolding = snipers.holding

  return (
    <PairSnipersBundlersInsidersTooltipBody
      bundlersHolding={bundlersHolding}
      snipersHolding={snipersHolding}
      insidersHolding={insiderHolding}
    />
  )
}
